var _path, _rect, _path2, _path3, _circle, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGanadera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92308 3C5.92308 4.52564 7.1 7.57692 11.8077 7.57692C16.5154 7.57692 17.6923 4.52564 17.6923 3M6.57692 14.7692V11.5M6.57692 7.57692C3.72905 7.60997 2.51541 9.44764 2.13318 10.7995C2.02875 11.1689 2.33039 11.5 2.71424 11.5H6.57692M6.57692 7.57692V9.53846V11.5M6.57692 7.57692H9.19231H17.0385M17.0385 7.57692V11.5M17.0385 7.57692C19.6538 7.57692 20.9373 9.39311 21.4186 10.7553C21.5532 11.1362 21.2476 11.5 20.8435 11.5H17.0385M17.0385 14.7692V11.5",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.26953,
    y: 14.7695,
    width: 13.0769,
    height: 5.23077,
    rx: 2.61538,
    stroke: "#2B363D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88672 17.3848H9.19441",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4258 17.3848H15.7335",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.098,
    cy: 11.8265,
    r: 0.980769,
    fill: "#2B363D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5006 11.8265C10.5006 12.3681 10.0615 12.8072 9.51983 12.8072C8.97817 12.8072 8.53906 12.3681 8.53906 11.8265C8.53906 11.2848 8.97817 10.8457 9.51983 10.8457C10.0615 10.8457 10.5006 11.2848 10.5006 11.8265Z",
    fill: "#2B363D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanadera);
export default __webpack_public_path__ + "static/media/Ganadera.e45ab25ddcca350b297ba3e8fe48b69a.svg";
export { ForwardRef as ReactComponent };